const copy = {
  enoticeName: 'Column, PBC'
};

export default copy;
